<template>
  <div class="company-info" :style="warpperStyle">
    <div class="invoice_nav">
      <navbar
        :lefticon="lefticon"
        :lefticonheight="1.8"
        :lefticonwidth="1.8"
        :fontweight="700"
        :fontsize="'1.7rem'"
        :titlecolor="'#333'"
        @goback="goBack(false)"
      />
    </div>
    <van-row class="title">
      <van-col span="12" class="tit">提交发票信息</van-col>
      <van-col span="12" class="info">
        <p>账单日期：{{ billInfo.bill_date }}</p>
        <p>应开金额：{{ billInfo.payable_amount }}</p>
      </van-col>
      <van-col span="24" class="con"
        >1、含税金额合计需≥应开金额，单张发票金额不足，可上传多张发票；</van-col
      >
      <van-col span="24" class="con"
        >2、点击“新增发票”按钮，可添加发票；</van-col
      >
      <van-col span="24" class="con">3、若发票是电子发票，直接上传；</van-col>
      <van-col span="24" class="con"
        >4、若发票是纸质发票，须拍照上传并邮寄到公司；</van-col
      >
    </van-row>
    <div class="content">
      <div
        class="invoice_info van-clearfix"
        v-for="(item, i) in invoiceInfo"
        :key="i"
      >
        <p class="title">
          <span class="ww">发票{{ i + 1 }}</span>
          <span class="bg"></span>
        </p>
        <van-row class="contract_type">
          <van-col span="12" class="tit">发票类型</van-col>
          <van-col span="12" class="label">
            <span>{{ item.contract_type }}</span>
          </van-col>
        </van-row>
        <div class="basic_info">
          <van-field
            v-model="item.including_tax_amount"
            label="含税金额(元)"
            class="marTop12 licensse"
            placeholder="请输入"
            :formatter="formatterMoney"
            type="number"
            pattern="number"
          />
          <van-field
            v-model="item.tax_rate"
            label="税率%"
            class="marTop12 licensse"
            placeholder="请输入"
            :formatter="formatterMoney"
            type="number"
            pattern="number"
          />
          <van-field
            v-model="item.tax_amount"
            label="税额(元)"
            class="marTop12 licensse"
            placeholder="请输入"
            :formatter="formatterMoney"
            type="number"
            pattern="number"
          />
          <van-field
            v-model="item.enterprise_name"
            label="企业名称"
            format-trigger="onBlur"
            class="marTop12 licensse"
            placeholder="请输入"
            onkeyup="value=value.replace(/![u4e00-u9fa5]/ig,'')"
            onafterpaste="this.value=this.value.replace(/![u4e00-u9fa5]/ig,'')"
          />
          <van-field
            v-model="item.invoice_code"
            label="发票代码"
            format-trigger="onBlur"
            class="marTop12 licensse"
            placeholder="请输入"
            onkeyup="value=value.replace(/[^\w]/ig,'')"
            onafterpaste="this.value=this.value.replace(/[^\w]/ig,'')"
          />
          <van-field
            v-model="item.statement_date"
            label="开票日期"
            format-trigger="onBlur"
            class="marTop12"
            placeholder="请选择 >"
            readonly
            @click="selectTime(i)"
          />

          <div class="uploadBox">
            <span class="title">发票图片<br />(1张)</span>
            <div class="img_box">
              <van-uploader
                v-model="item.fileList"
                multiple
                :max-count="1"
                preview-size="64px"
                @oversize="onOversize"
              >
                <div class="box">
                  <div class="icon">+</div>
                  <div class="title"></div>
                </div>
              </van-uploader>
            </div>
          </div>
        </div>
      </div>

      <p class="add" @click="addInvoice">
        <img src="@/assets/purchaseSupplier/withdraw/add.png" />
        新增发票
      </p>
    </div>
    <div class="complete" :style="completeStyle">
      <van-button @click="confirm" type="primary" class="operation_btn"
        >提交</van-button
      >
      <div class="complete-empty"></div>
    </div>

    <div class="loading" v-if="loading">
      <img src="../../../assets/common/loading.gif" />
    </div>

    <van-popup v-model="showdate" position="bottom">
      <van-datetime-picker
        @cancel="cancel"
        @confirm="selected($event)"
        :formatter="formatter"
        v-model="currentDate"
        type="date"
        :min-date="minDate"
      />
    </van-popup>
  </div>
</template>

<script>
import navbar from "../components/nav-bar.vue";
import { uploadMixin } from "../../debtRelief/mixin";
import Upload from "../../../providers/upload";
export default {
  data() {
    return {
      invoiceInfo: [],
      warpperStyle: { height: "100%" },
      completeStyle: { bottom: "0" },
      //   dialogShow: false,
      loading: false,
      lefticon: require("@/assets/accountAgent/common/back.png"),
      currentDate: new Date(),
      minDate: new Date(1920, 0, 1),
      showdate: false,
      index: 0,
      billInfo: {},
    };
  },
  components: {
    navbar,
  },
  created() {
    this.billInfo = JSON.parse(localStorage.getItem("billInfo"));
    let item = {
      contract_type: this.$route.query.contract_type,
      including_tax_amount: "",
      tax_rate: "",
      tax_amount: "",
      enterprise_name: "",
      invoice_code: "",
      statement_date: "",
      invoice_image: "",
      fileList: [],
    };
    this.invoiceInfo.push(item);
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
    }
  },
  mixins: [uploadMixin],
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    formatterMoney(value) {
      // 过滤输入的数字
      return value.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
    },
    selectTime(i) {
      this.index = i;
      this.showdate = true;
    },
    addInvoice() {
      let item = {
        contract_type: this.$route.query.contract_type,
        including_tax_amount: "",
        tax_rate: "",
        tax_amount: "",
        enterprise_name: "",
        invoice_code: "",
        statement_date: "",
        invoice_image: "",
        fileList: [],
      };
      this.invoiceInfo.push(item);
    },
    formatter(type, value) {
      if (type === "year") {
        return `${value}年`;
      } else if (type === "month") {
        return `${value}月`;
      } else if (type === "day") {
        return `${value}日`;
      }
    },
    selected(value) {
      this.showdate = false;
      var year = value.getFullYear();
      var month = value.getMonth() + 1;
      var day = value.getDate();
      this.invoiceInfo[this.index].statement_date =
        year +
        "-" +
        (month < 10 ? "0" + month : month) +
        "-" +
        (day < 10 ? "0" + day : day);
    },
    cancel() {
      this.showdate = false;
    },
    async confirm() {
      this.loading = true;
      for (let item of this.invoiceInfo) {
        if (item.fileList.length != 0) {
          let _files = await Upload.startUpload(
            item.fileList.map((_) => _.file),
            ["others"]
          );
          item.invoice_image = _files[0];
        }
      }
      await this.$api
        .post("member-relation/member/three/year/supplier/draw-bill", {
          info: this.invoiceInfo,
          bill_id: this.billInfo.id,
        })
        .then((data) => {
          this.$router.push({
            path: "/purchaseSupplier/result",
            query: {
              type: 3,
            },
          });
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    beforeRead(file) {
      if (file.size == 0 || JSON.stringify(file.file) == "{}") {
        //解决部分机型取消上传还是添加空白图片
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>


<style lang="less">
.company-info {
  overflow-x: hidden;
  padding: 8.8rem 0 6rem;
  box-sizing: border-box;
  color: #333;
  font-size: 1.4rem;
  background: #f5f6f7;

  .invoice_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    z-index: 3;
    background: #f5f6f7;
  }
  .title {
    padding: 0 1.6rem 1.4rem;

    .tit {
      height: 6.8rem;
      line-height: 6.8rem;
      color: #333;
      font-size: 2rem;
      font-weight: 700;
    }

    .info {
      text-align: right;
      color: #999;
      font-size: 1.2rem;
      font-weight: 400;
      padding-top: 1.1rem;

      p {
        line-height: 1.7rem;
        margin-bottom: 0.3rem;
      }
    }

    .con {
      color: #333;
      font-size: 1.4rem;
      line-height: 2.1rem;
      margin-bottom: 0.6rem;
    }
  }
  .content {
    padding: 0 1.6rem;
    position: relative;

    .invoice_info {
      min-height: 26rem;
      background: #fff;
      border-radius: 0.8rem;
      padding: 1.5rem 2rem 0.5rem 1.6rem;
      box-sizing: border-box;
      margin-bottom: 12px;

      .title {
        color: #333;
        font-size: 1.6rem;
        font-weight: 700;
        height: 2.2rem;
        line-height: 2.2rem;
        padding: 0;
        position: relative;

        .ww {
          color: #333;
          font-size: 1.6rem;
          font-weight: 700;
          height: 2.2rem;
          line-height: 2.2rem;
          position: absolute;
          bottom: 0;
          left: 0;
          z-index: 1;
        }

        .bg {
          width: 3.9rem;
          height: 0.4rem;
          display: inline-block;
          position: absolute;
          bottom: 0.2rem;
          left: 0;
          z-index: 0;
          background: -webkit-linear-gradient(
            to right,
            #fc740c,
            #f41a3c
          ); /* Safari 5.1 - 6.0 */
          background: -o-linear-gradient(
            to right,
            #fc740c,
            #f41a3c
          ); /* Opera 11.1 - 12.0 */
          background: -moz-linear-gradient(
            to right,
            #fc740c,
            #f41a3c
          ); /* Firefox 3.6 - 15 */
          background: linear-gradient(to right, #fc740c, #f41a3c);
        }
      }
      .contract_type {
        height: 5.4rem;
        line-height: 5.4rem;
        margin-top: 1.6rem;
        border-bottom: 0.05rem solid #ebedf0;

        .tit {
          color: #333;
          font-size: 1.4rem;
          font-weight: 700;
        }

        .label {
          text-align: right;

          span {
            color: #fff;
            width: 10rem;
            text-align: center;
            height: 2.6rem;
            line-height: 2.6rem;
            display: inline-block;
            margin-left: 1rem;
            border-radius: 0.4rem;
            font-size: 1.2rem;
            background: -webkit-linear-gradient(
              to right,
              #fc740c,
              #f41a3c
            ); /* Safari 5.1 - 6.0 */
            background: -o-linear-gradient(
              to right,
              #fc740c,
              #f41a3c
            ); /* Opera 11.1 - 12.0 */
            background: -moz-linear-gradient(
              to right,
              #fc740c,
              #f41a3c
            ); /* Firefox 3.6 - 15 */
            background: linear-gradient(to right, #fc740c, #f41a3c);
          }
        }
      }
      .van-cell {
        &::after {
          position: absolute;
          box-sizing: border-box;
          content: " ";
          pointer-events: none;
          right: 0;
          bottom: 0;
          left: 0 !important;
          border-bottom: 1px solid #ebedf0;
          -webkit-transform: scaleY(0.5);
          transform: scaleY(0.5);
        }
      }
      input::placeholder {
        color: #bababa;
        font-size: 14px;
      }
      .marTop12 {
        // margin-top: 12px;
        .van-field__control {
          font-size: 1.4rem;
          text-align: right;
        }
      }
      .basic_info {
        .van-cell {
          padding: 15px 0;
          &:not(:last-child)::after {
            position: absolute;
            box-sizing: border-box;
            content: " ";
            pointer-events: none;
            right: 0;
            bottom: 0;
            left: 16px;
            border-bottom: 1px solid #ebedf0;
            -webkit-transform: scaleY(0.5);
            transform: scaleY(0.5);
          }
        }
        .van-field__label {
          font-size: 1.4rem;
          color: #333;
          font-weight: bold;
          width: 7.5rem;
          margin-right: 1.5rem;
        }
      }
      .licensse {
        .van-field__label {
          width: 8.6rem;
        }
      }
      .uploadBox {
        margin-top: 17px;
        min-height: 76px;
        position: relative;
        .title {
          color: #333;
          font-size: 1.4rem;
          font-weight: 700;
          line-height: 2rem;
        }
        .img_box {
          max-width: 23rem;
          position: absolute;
          right: 0;
          top: 0;
        }
        .van-image__img,
        .van-image__error,
        .van-image__loading {
          object-fit: fill !important;
        }
        .box {
          width: 64px;
          height: 64px;
          background: #f5f6f7;
          border: 0.05rem solid #cccccc;
          border-radius: 0.8rem;
          box-sizing: border-box;
          .icon {
            text-align: center;
            color: #333;
            height: 16px;
            line-height: 16px;
            margin: 25px 0 0;
            font-size: 35px;
          }
          .title {
            text-align: center;
            font-size: 13px;
            height: 21px;
            line-height: 21px;
            color: #555555;
          }
        }
      }
      .uploadBox1 {
        width: 50%;
        float: left;
        .title {
          color: #999;
          font-size: 14px;
          height: 20px;
          line-height: 20px;
          margin-top: 8px;
          text-align: center;
        }
        .van-uploader {
          width: 100%;
          .van-uploader__input-wrapper {
            width: 100%;
            padding-right: 10px;
            .box {
              width: 100%;
              background: url(../../../assets/member/indetity/id_front.png)
                no-repeat center center;
              background-size: 100% 100%;
              img {
                width: 44px;
              }
            }
          }
          .van-uploader__preview {
            width: 100%;
            margin-right: 10px;
            .van-uploader__preview-image {
              width: 100% !important;
              .van-image__img,
              .van-image__error,
              .van-image__loading {
                object-fit: fill !important;
              }
            }
          }
        }
      }
      .uploadBox2 {
        .van-uploader {
          .van-uploader__input-wrapper {
            padding-left: 10px;
            .box {
              background: url(../../../assets/member/indetity/id_back.png)
                no-repeat center center;
              background-size: 100% 100%;
            }
          }
          .van-uploader__preview {
            margin-left: 10px;
            margin-right: 0px;
          }
        }
      }
    }

    .add {
      background: #fff;
      border-radius: 0.8rem;
      height: 64px;
      line-height: 64px;
      text-align: center;
      color: #333;
      font-size: 16px;
      font-weight: 700;

      img {
        width: 22px;
        margin-right: 8px;
        vertical-align: middle;
      }
    }
  }
  .complete {
    position: fixed;
    // bottom: 0;
    padding: 0 12px;
    // width: calc(100% - 24px);
    box-sizing: border-box;
    width: 100%;
    transition: bottom 0.1s linear;
    .complete-empty {
      height: 4px;
      width: 100%;
    }
    .operation_btn {
      color: #fff;
      border: none;
      width: 100%;
      margin: 0 auto;
      height: 44px;
      font-size: 16px;
      display: block;
      border-radius: 22px;
      line-height: 44px;
      font-weight: 600;
      background: -webkit-linear-gradient(to right, #fc740c, #f41a3c);
      /* Safari 5.1 - 6.0 */
      background: -o-linear-gradient(to right, #fc740c, #f41a3c);
      /* Opera 11.1 - 12.0 */
      background: -moz-linear-gradient(to right, #fc740c, #f41a3c);
      /* Firefox 3.6 - 15 */
      background: linear-gradient(to right, #fc740c, #f41a3c);
    }
  }
  .van-uploader__preview-delet {
    font-size: 26px;
  }

  .tip {
    padding: 0 10px;
    text-align: left;
  }
  .tipL {
    margin-bottom: 24px;
  }
  .van-dialog__header {
    padding: 20px 0 24px;
    font-weight: 500;
    line-height: 24px;
    text-align: center;
  }

  .loading {
    text-align: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    img {
      width: 35%;
      margin-top: 65%;
    }
  }
}
</style>





